import React, { useEffect } from "react";
import { Modal, Alert } from "react-bootstrap";
import AppButton from "../buyer/AppButton";
import theme from "../../styles/theme/theme";
import CustomAlert from "../common/CustomAlert";
import { useDispatch, useSelector } from "react-redux";
import {
  clearBuyerMessages,
  placeOrder,
} from "../../features/buyer/buyerSlice";
import { useNavigate } from "react-router-dom";
import { formatCurrency } from "../../utils/price";

const BuyConfirmModal = ({ show, onHide, onOrderSuccess, product }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.buyer.orderLoading);
  const error = useSelector((state) => state.buyer.orderError);
  const success = useSelector((state) => state.buyer.orderSuccess);

  useEffect(() => {
    if (show) {
      dispatch(clearBuyerMessages());
    }
  }, [show, dispatch]);

  const handleConfirm = async () => {
    // Navigate to shipping with 'fromBuyNow' flag and product data
    navigate(`/shipping-mode/${product.id}`, {
      state: {
        fromBuyNow: true,
        productParam: product,
      },
    });
    onHide();
  };

  const handleCancel = () => {
    dispatch(clearBuyerMessages());
    onHide();
  };

  return (
    <Modal show={show} onHide={handleCancel} centered>
      {/* Header */}
      <Modal.Header
        style={{
          backgroundColor: theme.palette.background.paper,
          borderBottom: `2px solid ${theme.palette.secondary.main}`,
        }}
      >
        <Modal.Title
          style={{
            fontWeight: 600,
            fontSize: "1.25rem",
            color: theme.palette.text.primary,
          }}
        >
          Confirm Purchase
        </Modal.Title>
      </Modal.Header>

      {/* Body */}
      <Modal.Body style={{ backgroundColor: theme.palette.background.paper }}>
        {success && (
          <CustomAlert
            type="success"
            message={typeof success === "object" ? success.message : success}
            onClose={() => dispatch(clearBuyerMessages())}
          />
        )}
        {error && (
          <Alert variant="danger" style={{ fontSize: "0.95rem" }}>
            {error}
          </Alert>
        )}

        <div
          className="mb-3"
          style={{ fontSize: "0.95rem", color: theme.palette.text.secondary }}
        >
          Are you sure you want to buy{" "}
          <strong style={{ color: theme.palette.text.primary }}>
            {product?.name}
          </strong>{" "}
          for{" "}
          <strong style={{ color: theme.palette.primary.main }}>
            {formatCurrency(product?.price)}
          </strong>
          ?
        </div>
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer
        style={{
          backgroundColor: theme.palette.background.paper,
          borderTop: `2px solid ${theme.palette.secondary.main}`,
        }}
      >
        <div style={styles.modalButtons}>
          <AppButton
            variant="outlined"
            onClick={handleCancel}
            style={{ marginRight: 12 }}
            disabled={loading}
          >
            Cancel
          </AppButton>
          <AppButton
            variant="contained"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? "Placing..." : "Yes, Confirm"}
          </AppButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default BuyConfirmModal;

const styles = {
  modalButtons: {
    width: 250,
    display: "flex",
    justifyContent: "flex-end",
  },
};
